<template>
  <a-layout class="full-height">
    <a-layout-sider width="220" class="bg_white" theme="light" v-model="collapsed" collapsible>
      <a-menu class="a-menu" :class="{ 'a-menu-hidden': collapsed === true }" v-model="basePath" mode="inline" @click="handleClick">
        <template v-for="menu in menuList">
          <a-menu-item v-if="menu.show" :key="menu.path">
            <a-icon :type="menu.iconType" />
            <span>{{ menu.name }}</span>
          </a-menu-item>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout-content class="bg_white p-m m-md">
      <router-view></router-view>
    </a-layout-content>
  </a-layout>
</template>
<script>
import { hasPermission } from '@/utils/utils';
import store from '@/store';
import Event from '@/utils/event';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      collapsed: false,
      basePath: [],
      menuList: [
        {
          name: '共享云盘',
          path: '/document/share',
          iconType: 'folder',
          show: false,
          permissionPath: '/document/share'
        },
        {
          name: '行业专家访谈',
          path: '/document/interview',
          iconType: 'phone',
          show: false,
          permissionPath: '/document/interview'
        },
        {
          name: 'Portfolio文件收集',
          path: '/document/fileCollection',
          iconType: 'flag',
          show: false,
          permissionPath: '/document/fileCollection'
        },
        {
          name: 'Portfolio Review',
          path: '/document/portfolioReview',
          iconType: 'read',
          show: false,
          permissionPath: '/document/portfolioReview/query'
        },
        {
          name: '文件调取',
          path: '/document/fileExtraction',
          iconType: 'file-search',
          show: false,
          permissionPath: '/document/fileExtraction'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    '$route.path': function(val) {
      if (val === '/document') {
        this.initMenu();
        this.initRoute();
      } else {
        this.setMenuOpenKey();
      }
    }
  },
  methods: {
    handleClick(e) {
      this.$router.push(e.key);
    },
    initMenu() {
      const { permissions: queue } = this.userInfo || {};
      this.menuList.forEach(_ => (_.show = hasPermission(queue, _.permissionPath)));
    },
    initRoute() {
      let defaultMenu = this.menuList.find(_ => _.show);
      let path = this.$route.path;
      if (defaultMenu && /^\/document\/?$/.test(path)) {
        this.$router.push(defaultMenu.path);
        path = defaultMenu.path;
      }
      this.basePath[0] = path;
    },
    setMenuOpenKey() {
      let current = this.menuList.find(v => v.path === this.$route.path);
      if (current) {
        if (!this.collapsed) {
          this.basePath = [current.path];
        }
      }
    }
  },
  created() {
    this.initMenu();
    this.initRoute();
    Event.$on('setPermission', this.initMenu);
  },
  beforeDestroy() {
    Event.$off('setPermission', this.initMenu);
  }
};
</script>
<style lang="less" scoped>
& /deep/ .ant-layout-sider-has-trigger .ant-layout-sider-children {
  height: calc(100vh - 94px);
  position: fixed;
  overflow: auto;
}
.a-menu {
  width: 220px;
  min-height: 100%;
}
.a-menu-hidden {
  width: 80px;
}
& /deep/ .ant-layout-sider-trigger {
  border: 1px solid #e8e8e8;
}
</style>
